import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/offer';

const sortTableFields = ["name", "active"];
const sortDatabaseFields = ["name","active"];

const serviceName = "Offer-Service: ";

export default class OfferService {

  static async readAllFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static async readAllPaginatedFromAPI(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, sortTableFields, sortDatabaseFields);
    await WrapperService.get(API_URL + '/page', {params : params}, serviceName, successF, errorF);
  }

  static async readFromAPI(emergencyId, successF, errorF) {
    await WrapperService.get(API_URL + '/' + emergencyId, null, serviceName, successF, errorF);
  }

  static async readElevatorFromAPI(elevatorFilter, successF, errorF) {
    await WrapperService.put(API_URL + '/filter', elevatorFilter, serviceName, successF, errorF);
  }

  static async checkAvailability(data, successF, errorF) {
    await WrapperService.put(API_URL + '/workload', data, serviceName, successF, errorF);
  }

  static async saveOffer(data, successF, errorF) {
    await WrapperService.post(API_URL + '/save', data, serviceName, successF, errorF);
  }

  static async deleteOffer(offer, successF, errorF) {
    await  WrapperService.delete(`${API_URL}/${offer.id}`, null, serviceName, successF, errorF);
  }

  static async sendPdfGenerationRequest(offerId, successF, errorF) {
    await WrapperService.get(API_URL + '/' + offerId + '/pdf', null, serviceName, successF, errorF);
  }

  static async sendPdfGenerationRequestByObject(offer, successF, errorF) {
    await WrapperService.put(API_URL + '/pdf', offer, serviceName, successF, errorF);
  }
}